var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isRR
    ? _c(
        "el-row",
        { attrs: { gutter: 20 } },
        _vm._l(_vm.setores, function(setor) {
          return _c(
            "el-col",
            { key: setor.setor.codigo, attrs: { sd: 12, xl: 8, md: 12 } },
            [
              setor.setor.codigo !== "TECNICO_DE_CAMPO"
                ? _c("card-setor", {
                    attrs: { setorWithCount: setor },
                    on: {
                      click: function($event) {
                        return _vm.goToProdutividade(setor.setor.codigo)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    : _c("home-RR")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47362bab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47362bab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/Home.vue
// module id = null
// module chunks = 